import { Routes, Route, useLocation } from "react-router-dom";
import { PageShell, PageTransition, CookieConsent, BackToTop } from "@site-factory/ui";
import { siteConfig } from "./site.config";
import StyleGuidePage from "./pages/StyleGuidePage";
import GalleryPage from "./pages/GalleryPage";
import ContactPage from "./pages/ContactPage";
import ThemePage from "./pages/ThemePage";
import { RouterLink } from "./components/RouterLink";

function AppShell() {
  const location = useLocation();

  return (
    <PageShell
      siteName={siteConfig.name}
      navigation={siteConfig.navigation}
      currentPath={location.pathname}
      linkComponent={RouterLink}
    >
      <PageTransition location={location}>
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<GalleryPage />} />
          <Route path="/styleguide" element={<StyleGuidePage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/theme" element={<ThemePage />} />
        </Routes>
      </PageTransition>
    </PageShell>
  );
}

export default function App() {
  return (
    <>
      <AppShell />
      <CookieConsent
        enabled
        message="We use cookies to personalize content and analyze traffic."
        acceptText="Accept"
        declineText="Decline"
        position="bottom"
        privacyPolicyUrl="#"
      />
      <BackToTop />
    </>
  );
}
